lmApp
  .controller('RailsController', ['$scope', '$rootScope', '$q', '$templateCache', '$compile', '$routeParams', '$location', 'MetadataService', 'RailResource', 'TimezoneService', 'CategoryService', 'GenreService', 'AdsResource', 'AdsService', 'ModalWindowService', 'ToastService', 'ManageAssetsWindow', 'OperatorResource', 'GenreResource', 'CategoryResource', 'AssetResource',
    function ($scope, $rootScope, $q, $templateCache, $compile, $routeParams, $location, MetadataService, RailResource, TimezoneService, CategoryService, GenreService, AdsResource, AdsService, ModalWindowService, ToastService, ManageAssetsWindow, OperatorResource, GenreResource, CategoryResource, AssetResource) {
      $scope.loading = false;
      $scope.selectedTab = 'screens';

      $scope.setTab = function (tab) {
          $scope.selectedTab = tab;
          $scope.clearActiveRail();
          $scope.clearActiveScreen();
      };

        $scope.screens = []
        $scope.rails = []
        $scope.ads = []

        $scope.screen = {}
        $scope.banners = {
            firstElement: 0,
            _CSS: {
                left: 0,
            },
            sliderItems: []
        }
        $scope.rail = {}

        $scope.moreVariants = [
            {
                id: '',
                title: 'Default'
            },
            {
                id: 'ui://tv',
                title: 'TV section'
            },
            {
                id: 'ui://vod',
                title: 'VOD section'
            },
        ];

        $scope.menu = []
        $scope.menuLogo = {
            url: '',
        }

        $scope.locLangs = angular.copy(MetadataService.languages.list);
        var langCodeToTitle = {};
        for (var i = 0; i < $scope.locLangs.length; i++) {
            var lang = $scope.locLangs[i];
            langCodeToTitle[lang.id] = lang;
        }

        $scope.menuIcons = [
            {
                id: 'home',
                title: 'home'
            },
            {
                id: 'tv',
                title: 'tv'
            },
            {
                id: 'vod',
                title: 'vod'
            },
            {
                id: 'mylist',
                title: 'mylist'
            }
        ]

        $scope.menuTitles = [
            {
                id: 'custom',
                title: 'Custom'
            },
            {
                id: 'menu_home',
                title: 'menu_home'
            },
            {
                id: 'menu_myList',
                title: 'menu_myList'
            },
            {
                id: 'menu_tv',
                title: 'menu_tv'
            },
            {
                id: 'menu_video',
                title: 'menu_video'
            },
        ]

        $scope.menuOptions = [
            {
                id: 'home',
                title: 'Default screen "Home"',
                scheme: 'ui',
                path: 'homepage',
                icon: 'home',
                menu_title: 'menu_home',
                default: true,
            },
            {
                id: 'mylist',
                title: 'Default screen "My List"',
                scheme: 'ui',
                path: 'mylist',
                icon: 'mylist',
                menu_title: 'menu_myList',
                default: true,
            },
            {
                id: 'tv',
                title: 'Default screen "TV"',
                scheme: 'ui',
                path: 'tv',
                icon: 'tv',
                menu_title: 'menu_tv',
                default: true,
            },
            {
                id: 'vod',
                title: 'Default screen "Video"',
                scheme: 'ui',
                path: 'vod',
                icon: 'vod',
                menu_title: 'menu_video',
                default: true,
            }
        ]

        var convertEditedMenuToJsonAPI = function () {
            var processed = {
                scheme: $scope.editedMenu.option.scheme,
                path: $scope.editedMenu.option.path,
                icon: $scope.editedMenu.icon.id,
                title: $scope.editedMenu.title.id || '',
            }
            if ($scope.editedMenu.title.id === 'custom') {
                processed.title = $scope.editedMenu.customTitle;
            }
            if ($scope.editedMenu.localization.length) {
                processed.l10n = {};
                for (var i = 0; i < $scope.editedMenu.localization.length; i += 1) {
                    var loc = $scope.editedMenu.localization[i];
                    processed.l10n[loc.lang.id.toLowerCase()] = {title: loc.title}
                }
            }
            return processed
        }

        var convertMenuToJsonAPI = function (m) {
            var processed = {
                url: m.scheme + '://' + m.path,
                icon: m.icon,
                title: m.title,
            }
            if (m.l10n) {
                processed.l10n = m.l10n;
            }
            return processed
        }

        var normMenuObj = function (m) {
            var processed = {
                scheme:'',
                path: '',
                icon: m.icon || '',
                title: m.title || '',
                localization: [],
            }
            var url = m.url || '';
            var parts = url.split('://')
            if (parts.length === 2) {
                processed.scheme = parts[0]
                processed.path = parts[1]
            }
            if (m.l10n) {
                for (var langCode in m.l10n) {
                    var code = langCode.toUpperCase()
                    if (langCodeToTitle.hasOwnProperty(code))
                    processed.localization.push({
                        lang: langCodeToTitle[code],
                        title: m.l10n[langCode].title || '',
                    })
                }
            }
            return processed
        }

        $scope.getScreens = function () {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var params = {};
            params['$expand'] = 'rails';

            $scope.ads = [];

            RailResource.getScreens(params).$promise
                .then(function (data) {
                    var screens = data || []
                    for (var i = 0; i < screens.length; i += 1) {
                        if (!screens[i].rails) {
                            screens[i].rails = []
                        }
                        screens[i].createTime = new Date(screens[i].create_time);
                        $scope.moreVariants.push({
                            id: 'screen://' + screens[i].ext_id,
                            title: 'Screen "' + screens[i].name +'"'
                        })
                        $scope.menuOptions.push({
                            id: 'screen' + screens[i].id,
                            title: 'Custom screen "' + screens[i].name +'"',
                            scheme: 'screen',
                            path: screens[i].ext_id,
                            icon: '',
                            menu_title: '',
                            default: false,
                        })
                    }
                    $scope.screens = screens

                    params['$expand'] = 'preview(asset(conditions,resources(url))),content_n';
                    RailResource.get(params).$promise
                        .then(function (data) {
                            var rails = data || []
                            for (var i = 0; i < rails.length; i += 1) {
                                rails[i].selected = false
                                if (!rails[i].preview) rails[i].preview = []
                                for (var k = 0; k < rails[i].preview.length; k += 1) {
                                    rails[i].preview[k].asset = processAsset(rails[i].preview[k].asset)
                                }
                            }
                            $scope.rails = rails
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                        })
                        .catch(function (reason) {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                            $rootScope.debugInfo(reason, 'silent');
                            ToastService.Small({
                                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                                color: 'amber',
                                icon: 'server-off',
                                blocked: true
                            }, 1000 * 3);
                        })

                    AdsResource.get().$promise
                        .then(function (data) {
                            var assetIDs = [];
                            $scope.ads = data.map(function (ad, i) {
                                ad.picture = {
                                    url: '',
                                    state: '',
                                }
                                if (ad.pictures && ad.pictures.length > 0) {
                                    ad.picture.url = ad.pictures[0].url;
                                    ad.picture.state = ad.pictures[0].state;
                                }
                                if (ad.condition_in_rotation === "ok" && ad.condition_pictures_available === "ok") {
                                    ad._status = "active"
                                } else {
                                    ad._status = "inactive"
                                }
                                ad.valid = true
                                if (ad.url && ad.url.startsWith("asset://")) {
                                    var id = Number(ad.url.split('://')[1])
                                    if (id) assetIDs.push(id)
                                }
                                return ad;
                            });
                            return assetIDs
                        })
                        .then(function (assetIDs) {
                            if (assetIDs.length) {
                                AssetResource.get({'id[in]': assetIDs.join(',')}).$promise
                                    .then(function (data) {
                                        var assetMap = {};
                                        data.forEach(function (asset) {
                                            assetMap[asset.id] = asset;
                                        });
                                        angular.forEach($scope.ads, function(ad) {
                                            if (ad.url && ad.url.startsWith("asset://")) {
                                                var id = Number(ad.url.split('://')[1])
                                                if (id && !assetMap.hasOwnProperty(id)) {
                                                    ad.valid = false
                                                }
                                            }
                                        });
                                    })
                                    .catch(function (reason) {
                                        $rootScope.debugInfo(reason, 'silent');
                                        ToastService.Small({
                                            title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                                            color: 'amber',
                                            icon: 'server-off',
                                            blocked: true
                                        }, 1000 * 3);
                                    });
                            }
                        })
                        .catch(function (reason) {
                            $scope.loading = false;
                            $rootScope.debugInfo(reason, 'silent');
                            ToastService.Small({
                                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                                color: 'amber',
                                icon: 'server-off',
                                blocked: true
                            }, 1000 * 3);
                        })
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                })
        }

        OperatorResource.getConfigHootko().$promise
            .then(function (data) {
                if (data.data.menu && data.data.menu.length) {
                    for (var i = 0; i < data.data.menu.length; i += 1) {
                        var m = data.data.menu[i];
                        $scope.menu.push(normMenuObj(m));
                    }
                }
                if (data.data.design && data.data.design.logo_url) {
                    $scope.menuLogo.url = data.data.design.logo_url;
                }
            })
            .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
            })

        var processCondition = function (condition) {
            return {
                id: condition.id || 0,
                required: condition.required || false,
                type: condition.type || '',
                state: condition.state || ''
            }
        };

        var processAsset = function(asset) {
            var processed = {
                id: asset.id,
                extid: asset.ext_id,
                type: asset.type,
                name: asset.name,
                description: asset.description,
                lcn: asset.lcn,
                rotationStart: asset.rotation_start,
                rotationFinish: asset.rotation_finish,
                provider: asset.provider ? asset.provider.name : '',
                categories: asset.categories || [],
                genres: asset.genres || [],
                poster: {
                    state: '',
                    url: '',
                    source: ''
                },
                rotationPeriodOK: true,
                conditions: {
                    ready: processCondition({})
                },
                order: 0,
            };

            if (moment(asset.rotation_start).diff(moment()) > 0 || moment(asset.rotation_finish).diff(moment()) < 0) {
                processed.rotationPeriodOK = false;
            }

            if (asset.resources) {
                for (var i = 0; i < asset.resources.length; i++) {
                    var r = asset.resources[i]
                    if (r.type === 'picture') {
                        processed.poster.state = r.state;
                        processed.poster.url = r.url;
                        processed.poster.source = r.source;
                    }
                }
            }

            if (asset.conditions) {
                var ready = asset.conditions.filter(function(c) {
                    if (c.type === 'ready') return c;
                });
                if (ready.length) {
                    processed.conditions.ready = processCondition(ready[0]);
                }
            }

            return processed;
        };

        $scope.getScreen = function (id) {
            $scope.selectedTab = 'screens';

            $scope.screen.id = id

            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var params = {};
            params['id[eq]'] = id;
            params['$expand'] = 'rails(preview(thumbnail_url,asset(conditions,resources(url))),content_n),carousel(tags,pictures)';

            $scope.banners.sliderItems = [{},{}];
            $scope.banners.firstElement = 0;
            $scope.banners._CSS.left = 0;

            RailResource.getScreens(params).$promise
                .then(function (data) {
                    var screens = data || []
                    for (var i = 0; i < screens.length; i += 1) {
                        if (!screens[i].rails) {
                            screens[i].rails = []
                        }
                        if (!screens[i].carousel) {
                            screens[i].carousel = []
                        }
                        screens[i].createTime = new Date(screens[i].create_time);

                        for (var j = 0; j < screens[i].rails.length; j += 1) {
                            screens[i].rails[j].order = j + 1
                            if (!screens[i].rails[j].preview) screens[i].rails[j].preview = []
                            for (var k = 0; k < screens[i].rails[j].preview.length; k += 1) {
                                screens[i].rails[j].preview[k].asset = processAsset(screens[i].rails[j].preview[k].asset)
                            }
                        }
                    }

                    if (screens.length > 0) {
                        $scope.screen = screens[0]
                        if ($scope.screen.carousel && $scope.screen.carousel.length) {
                            $scope.banners.sliderItems = [];
                            for (var j = 0; j < $scope.screen.carousel.length; j += 1) {
                                var newSlide = {};
                                var ad = $scope.screen.carousel[j];
                                if (ad.pictures && ad.pictures.length > 0) {
                                    newSlide.picture = ad.pictures[0].url;
                                    newSlide.state = ad.pictures[0].state;
                                }
                                newSlide.name = ad.name;
                                $scope.banners.sliderItems.push(newSlide);
                            }
                        }
                    } else {
                        $scope.clearActiveScreen()
                    }

                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                })
        }

        $scope.getRail = function (id) {
            $scope.selectedTab = 'rails';
            $scope.rail.id = id

            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var params = {};
            params['id[eq]'] = id;
            params['$expand'] = 'preview(thumbnail_url,asset)';

            RailResource.get(params).$promise
                .then(function (data) {
                    var rails = data || []
                    for (var i = 0; i < rails.length; i += 1) {
                        rails[i].assets = [];
                        rails[i].type = 'live';
                    }
                    if (rails.length > 0) {
                        if (!rails[0].more) {
                            rails[0].more = '';
                        }
                        for (var i = 0; i < $scope.moreVariants.length; i += 1) {
                            if ($scope.moreVariants[i].id === rails[0].more) {
                                rails[0].more = $scope.moreVariants[i];
                                break;
                            }
                        }
                        $scope.rail = rails[0]
                    } else {
                        $scope.clearActiveRail()
                    }

                    params = {};
                    params['$expand'] = 'asset(resources(url),genres,conditions)';
                    RailResource.getRailContent({id: id}, params).$promise
                        .then(function (data) {
                            var assets = data || []
                            for (var i = 0; i < assets.length; i += 1) {
                                var asset = processAsset(assets[i].asset);
                                asset.order = i + 1;
                                $scope.rail.assets.push(asset);
                            }
                            if (assets.length && assets[0].asset.type !== 'channel') {
                                $scope.rail.type = 'vod';
                            }

                            var found = false
                            for (var i = 0; i < $scope.rails.length; i += 1) {
                                if ($scope.rails[i].id == $scope.rail.id) {
                                    found = true
                                    break
                                }
                            }
                            if (!found) {
                                $scope.rails.push($scope.rail)
                            }

                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                        })
                        .catch(function (reason) {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                            $rootScope.debugInfo(reason, 'silent');
                            ToastService.Small({
                                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                                color: 'amber',
                                icon: 'server-off',
                                blocked: true
                            }, 1000 * 3);
                        })
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                })
        }

        $scope.getScreens()

        var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
        $scope.convertTime = function (dt) {
            return TimezoneService.addTimezoneToDate(dt, timezone)
        };

        $scope.isActiveScreenSet = function () {
            return !_.isEmpty($scope.screen);
        };

        $scope.isActiveRailSet = function () {
            return !_.isEmpty($scope.rail);
        };

        $scope.setActiveScreen = function (screen) {
            //$scope.screen = screen
            $scope.clearActiveRail();
            $location.search('screen_id', screen.id);
        }

        $scope.setActiveRail = function (rail) {
            $scope.clearActiveScreen();
            $location.search('rail_id', rail.id);
        }

        $scope.clearActiveScreen = function () {
            $scope.screen = {};
            $location.search('screen_id', null);
        };

        $scope.clearActiveRail = function () {
            $scope.rail = {};
            $location.search('rail_id', null);
        };

        if ($routeParams.screen_id) {
            $scope.getScreen($routeParams.screen_id)
            $scope.clearActiveRail()
        } else if ($routeParams.rail_id) {
            $scope.getRail($routeParams.rail_id)
            $scope.clearActiveScreen()
        }

        $scope.$on('$routeUpdate', function () {
            if (!$routeParams.screen_id) {
                $scope.clearActiveScreen();
            }
            if (!$routeParams.rail_id) {
                $scope.clearActiveRail();
            }
            if ($routeParams.screen_id) {
                $scope.getScreen($routeParams.screen_id)
            } else if ($routeParams.rail_id) {
                $scope.getRail($routeParams.rail_id)
            }

        });

        $scope.changeContent = function() {
            $scope.railList = angular.copy($scope.rails);

            var selectedRails = {}
            for (var i = 0; i < $scope.screen.rails.length; i += 1) {
                selectedRails[$scope.screen.rails[i].id] = i
            }

            for (var i = 0; i < $scope.railList.length; i += 1) {
                if (selectedRails.hasOwnProperty($scope.railList[i].id)) {
                    $scope.railList[i].selected = true
                    $scope.railList[i].order = selectedRails[$scope.railList[i].id]
                }
            }

            var inner = $templateCache.get('rails-change-content.tpl.html');
            inner = $compile(inner)($scope);

            $scope.window = ModalWindowService.Open({
                content: inner,
                clear: true,
                isFixed: true,
                keyboard: true,
                actions: [
                    {
                        title: 'Save',
                        color: 'green',
                        fn: function () {
                            //var newRailList = []
                            $scope.screen.rails = []
                            var list = _.sortBy($scope.railList, 'order');
                            for (var i = 0; i < list.length; i += 1) {
                                if (list[i].selected) {
                                    $scope.screen.rails.push(list[i])
                                }
                            }
                            for (var i = 0; i < $scope.screen.rails.length; i += 1) {
                                $scope.screen.rails[i].order = i + 1;
                            }
                            $scope.$apply();

                            //$scope.loading = false;
                            $rootScope.hideLinearProgress('#modalLoader');
                        }
                    },
                    {
                        title: 'Cancel',
                        color: 'red',
                        fn: function () {
                            $rootScope.hideLinearProgress('#modalLoader');
                        }
                    }
                ],
                size: {
                    s: 12,
                    l: 8
                }
            });
        };

        $scope.addScreen = function () {
            $scope.screen = {
                id: 0,
                name: '',
                ext_id: '',
                rails: [],
            }
        }

        var isScreenValid = function() {
            $scope.validateErrors = {};

            var valid = true;
            if (!_.trim($scope.screen.name)) {
                $scope.validateErrors.name = true;
                valid = false;
            }
            if (!_.trim($scope.screen.ext_id)) {
                $scope.validateErrors.ext_id = true;
                valid = false;
            }
            return valid;
        };

        $scope.saveScreen = function () {
            if (!isScreenValid()) {
                return
            }

            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var saved = {
                ext_id: $scope.screen.ext_id,
                name: $scope.screen.name,
                rails: [],
            }

            for (var i = 0; i < $scope.screen.rails.length; i += 1) {
                saved.rails.push({ id: $scope.screen.rails[i].id })
            }

            if ($scope.screen.id > 0) {
                RailResource.patchScreen({id: $scope.screen.id}, saved).$promise
                    .then(function () {
                        ToastService.Small({
                            title: 'The screen has been updated',
                            color: 'green',
                            icon: 'check'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    })
                    .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                        ToastService.Small({
                            title: 'Failed to save: ' + _.get(reason, 'data.error.message', 'server error'),
                            color: 'red',
                            icon: 'server-minus'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    });
            } else {
                RailResource.createScreen(saved).$promise
                    .then(function (result) {
                        $scope.screen.id = result.data.id
                        $scope.screen.create_time = result.data.create_time
                        $scope.screens.push($scope.screen)
                        $scope.getScreen($scope.screen.id)
                        ToastService.Small({
                            title: 'The screen has been created',
                            color: 'green',
                            icon: 'check'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    })
                    .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                        ToastService.Small({
                            title: 'Failed to create screen: ' + _.get(reason, 'data.error.message', 'server error'),
                            color: 'red',
                            icon: 'server-minus'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    });
            }
        }

        $scope.addRail = function () {
            $scope.rail = {
                id: 0,
                name: '',
                type: 'vod',
                ext_id: '',
                assets: [],
            }
        }

        var isRailValid = function() {
            $scope.railValidateErrors = {};

            var valid = true;
            if (!_.trim($scope.rail.name)) {
                $scope.railValidateErrors.name = true;
                valid = false;
            }
/*            if (!_.trim($scope.rail.ext_id)) {
                $scope.railValidateErrors.ext_id = true;
                valid = false;
            }*/
            return valid;
        };

        $scope.saveRail = function () {
            if (!isRailValid()) {
                return
            }

            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var updated = {
                ext_id: $scope.rail.ext_id,
                name: $scope.rail.name,
                more: $scope.rail.more.id,
                content: [],
            }

            for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                updated.content.push({asset_id: $scope.rail.assets[i].id})
            }

            if ($scope.rail.id > 0) {
                RailResource.patch({id: $scope.rail.id}, updated).$promise
                    .then(function () {
                        ToastService.Small({
                            title: 'The rail has been updated',
                            color: 'green',
                            icon: 'check'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    })
                    .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                        ToastService.Small({
                            title: 'Failed to save: ' + _.get(reason, 'data.error.message', 'server error'),
                            color: 'red',
                            icon: 'server-minus'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    });
            } else {
                var created = {
                    ext_id: $scope.rail.ext_id,
                    name: $scope.rail.name,
                    more: $scope.rail.more.id,
                    content: [],
                }
                for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                    created.content.push({asset_id: $scope.rail.assets[i].id})
                }

                RailResource.createRail(created).$promise
                    .then(function (result) {
                        $scope.getRail(result.data.id)
                        ToastService.Small({
                            title: 'The rail has been created',
                            color: 'green',
                            icon: 'check'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    })
                    .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                        ToastService.Small({
                            title: 'Failed to create rail: ' + _.get(reason, 'data.error.message', 'server error'),
                            color: 'red',
                            icon: 'server-minus'
                        });
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#screenLoader');
                    });
            }
        }

        $scope.deleteScreen = function () {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var screen = $scope.screen;

            $scope.modalWindowScope = $scope.$new();
            var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the screen "' + screen.name +'"?</span>';

            ModalWindowService.Open({
                content: inner,
                actions: [
                    {
                        title: 'I understand. Do it',
                        color: 'green',
                        fn: function () {
                            RailResource.removeScreen({id: screen.id}).$promise
                                .then(function () {
                                    var index = $scope.screens.indexOf(screen);
                                    $scope.screens.splice(index, 1);
                                    ToastService.Small({
                                        title: 'The screen has been removed',
                                        color: 'green',
                                        icon: 'delete'
                                    });
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#screenLoader');
                                    $scope.clearActiveScreen();
                                })
                                .catch(function (reason) {
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#screenLoader');
                                    $rootScope.debugInfo(reason);
                                    ToastService.Small({
                                        title: 'Failed to remove screen: ' + _.get(reason, 'data.error.message', 'server error'),
                                        color: 'red',
                                        icon: 'alert'
                                    });
                                });
                        }
                    },
                    {
                        title: 'cancel',
                        color: 'red',
                        fn: function () {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                        }
                    }
                ],
                onComplete: function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                    $scope.modalWindowScope.$destroy();
                }
            });
        };

        $scope.deleteRail = function (rail) {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            $scope.modalWindowScope = $scope.$new();
            var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the rail "' + rail.name +'"?</span>';

            ModalWindowService.Open({
                content: inner,
                actions: [
                    {
                        title: 'I understand. Do it',
                        color: 'green',
                        fn: function () {
                            RailResource.remove({id: rail.id}).$promise
                                .then(function () {
                                    var index = $scope.rails.indexOf(rail);
                                    $scope.rails.splice(index, 1);
                                    ToastService.Small({
                                        title: 'The rail has been removed',
                                        color: 'green',
                                        icon: 'delete'
                                    });
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#screenLoader');
                                })
                                .catch(function (reason) {
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#screenLoader');
                                    $rootScope.debugInfo(reason);
                                    ToastService.Small({
                                        title: 'Failed to remove rail: ' + _.get(reason, 'data.error.message', 'server error'),
                                        color: 'red',
                                        icon: 'alert'
                                    });
                                });
                        }
                    },
                    {
                        title: 'cancel',
                        color: 'red',
                        fn: function () {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#screenLoader');
                        }
                    }
                ],
                onComplete: function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                    $scope.modalWindowScope.$destroy();
                }
            });
        };

        var convertAsset = function(asset) {
            var processed = {
                id: asset.id,
                extid: asset.extid,
                type: asset.type,
                name: asset.title,
                genres: asset.genres || [],
                poster: {
                    state: '',
                    url: '',
                    source: ''
                },
                conditions: {
                    ready: {
                        state: asset.is_available ? 'ok' : 'error'
                    }
                }
            };

            if (asset.resources) {
                for (var i = 0; i < asset.resources.length; i++) {
                    var r = asset.resources[i]
                    if (r.type === 'picture') {
                        processed.poster.state = r.is_deployed ? 'deployed' : 'deployment-error';
                        processed.poster.url = r.source;
                        processed.poster.source = r.source;
                    }
                }
            }

            return processed;
        };

        $scope.manageAssets = function (toAdd, toRemove, toThis) {
            var removed = {}
            for (var i = 0; i < toRemove.length; i += 1) {
                removed[toRemove[i].id] = true
            }

            var newList = []
            for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                if (!removed.hasOwnProperty($scope.rail.assets[i].id)) {
                    newList.push($scope.rail.assets[i])
                }
            }

            for (var i = 0; i < toAdd.length; i += 1) {
                newList.push(convertAsset(toAdd[i]))
            }

            $scope.rail.assets = newList
            for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                $scope.rail.assets[i].order = i + 1;
            }
        };

        $scope.changeRailContent = function () {
            ManageAssetsWindow.OpenManageAssetsWindow({
                manageAssetsFn: $scope.manageAssets,
                title: 'selecting content for the rail ' + $scope.rail.name,
                view: $scope.rail.type,
                currentCollection: _.map($scope.rail.assets, 'id'),
                filter: {}
            });
        };

        $scope.slideLeft = function () {
            $scope.banners.firstElement -= 1;
            if ($scope.banners.firstElement < 0) {
                $scope.banners.firstElement = 0;
            }
            $scope.banners._CSS.left = '-' + (33.333 * $scope.banners.firstElement) + '%';
        };

        $scope.slideRight = function () {
            if ($scope.banners.firstElement !== $scope.banners.sliderItems.length - 2) {
                $scope.banners.firstElement += 1;
                $scope.banners._CSS.left = '-' + (33.333 * $scope.banners.firstElement) + '%';
            }
        };

        $scope.editSlider = function () {
            $scope.bannerList = [];
            for (var i = 0; i < $scope.ads.length; i += 1) {
                if (!$scope.ads[i].valid) continue
                $scope.bannerList.push($scope.ads[i])
            }

            var selected = {}
            for (var i = 0; i < $scope.screen.carousel.length; i += 1) {
                selected[$scope.screen.carousel[i].id] = i
            }

            for (var i = 0; i < $scope.bannerList.length; i += 1) {
                if (selected.hasOwnProperty($scope.bannerList[i].id)) {
                    $scope.bannerList[i].selected = true
                    //$scope.bannerList[i].order = selectedRails[$scope.railList[i].id]
                }
            }

            var inner = $templateCache.get('screen-change-banners.tpl.html');
            inner = $compile(inner)($scope);

            $scope.window = ModalWindowService.Open({
                content: inner,
                clear: true,
                isFixed: true,
                keyboard: true,
                actions: [
                    {
                        title: 'Save',
                        color: 'green',
                        fn: function () {
                            var reqList = [];
                            var screenTag = 'screen:' + $scope.screen.id;
                            for (var i = 0; i < $scope.bannerList.length; i += 1) {
                                var tags = [];
                                var tagFound = false;
                                if ($scope.bannerList[i].tags && $scope.bannerList[i].tags.length) {
                                    for (var j = 0; j < $scope.bannerList[i].tags.length; j += 1) {
                                        var tag = $scope.bannerList[i].tags[j];
                                        if (tag === screenTag && $scope.bannerList[i].selected) {
                                            tagFound = true;
                                        }
                                        if (tag === screenTag && !$scope.bannerList[i].selected) {
                                            continue
                                        }
                                        tags.push(tag);
                                    }
                                }
                                if (!tagFound && $scope.bannerList[i].selected) {
                                    tags.push(screenTag);
                                }

                                var patchedAd = {
                                    tags: tags,
                                }
                                reqList.push(AdsResource.update({id: $scope.bannerList[i].id}, patchedAd).$promise)
                            }
                            if (reqList.length) {
                                var patchedScreen = {
                                    carousel_tag: screenTag,
                                }
                                reqList.push(RailResource.patchScreen({id: $scope.screen.id}, patchedScreen).$promise)
                            }

                            $q.all(reqList)
                                .then(function(values) {
                                    $scope.getScreen($scope.screen.id)
                                    ToastService.Small({
                                        title: 'The screen has been updated',
                                        color: 'green',
                                        icon: 'check'
                                    });
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#modalLoader');
                                })
                                .catch(function(reason) {
                                    $scope.loading = false;
                                    $rootScope.hideLinearProgress('#modalLoader');
                                    $rootScope.debugInfo(reason);
                                    ToastService.Small({
                                        title: 'Failed to update screen: ' + _.get(reason, 'data.error.message', 'server error'),
                                        color: 'red',
                                        icon: 'alert'
                                    });
                                });
                        }
                    },
                    {
                        title: 'Cancel',
                        color: 'red',
                        fn: function () {
                            $rootScope.hideLinearProgress('#modalLoader');
                        }
                    }
                ],
                size: {
                    s: 12,
                    l: 8
                }
            });
        }

        $scope.setMenu = function (menu) {
            if (menu) {
                for (var i = 0; i < $scope.menuOptions.length; i += 1) {
                    if ($scope.menuOptions[i].scheme === menu.scheme && $scope.menuOptions[i].path === menu.path) {
                        $scope.editedMenu.option = $scope.menuOptions[i];
                        break;
                    }
                }
                for (var i = 0; i < $scope.menuIcons.length; i += 1) {
                    if ($scope.menuIcons[i].id === menu.icon) {
                        $scope.editedMenu.icon = $scope.menuIcons[i];
                        break;
                    }
                }
                for (var i = 0; i < $scope.menuTitles.length; i += 1) {
                    if ($scope.menuTitles[i].id === menu.title) {
                        $scope.editedMenu.title = $scope.menuTitles[i];
                        break;
                    }
                }
                if (!$scope.editedMenu.title.id) {
                    $scope.editedMenu.title =  $scope.menuTitles[0]
                    $scope.editedMenu.customTitle = menu.title;
                }
                if (menu.localization.length) {
                    $scope.editedMenu.localization = angular.copy(menu.localization);
                }
            }
            if (!$scope.editedMenu.icon.id) {
                for (var i = 0; i < $scope.menuIcons.length; i += 1) {
                    if ($scope.menuIcons[i].id === $scope.editedMenu.option.icon) {
                        $scope.editedMenu.icon = $scope.menuIcons[i];
                        break;
                    }
                }
            }
            if (!$scope.editedMenu.icon.id) {
                $scope.editedMenu.icon =  $scope.menuIcons[0]
            }
            if (!$scope.editedMenu.title.id) {
                for (var i = 0; i < $scope.menuTitles.length; i += 1) {
                    if ($scope.menuTitles[i].id === $scope.editedMenu.option.menu_title) {
                        $scope.editedMenu.title = $scope.menuTitles[i];
                        break;
                    }
                }
            }
            if (!$scope.editedMenu.title.id) {
                $scope.editedMenu.title =  $scope.menuTitles[0]
            }
        }

        $scope.changeMenuOption = function (option) {
            $scope.editedMenu = {
                option: option,
                icon: {},
                menu: {},
                title: {},
                customTitle: '',
                localization: [],
            }
            $scope.setMenu()
        }

        $scope.saveMenu = function () {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#screenLoader');

            var data = {
                menu: [],
                design: {},
            }
            for (var i = 0; i < $scope.menu.length; i += 1) {
                data.menu.push(convertMenuToJsonAPI($scope.menu[i]))
            }

            if ($scope.menuLogo.url) {
                data.design.logo_url = $scope.menuLogo.url;
            }

            OperatorResource.updateConfigHootko(data).$promise
                .then(function (result) {
                    ToastService.Small({
                        title: 'The menu has been updated',
                        color: 'green',
                        icon: 'check'
                    });
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Failed to update menu: ' + _.get(reason, 'data.error.message', 'server error'),
                        color: 'red',
                        icon: 'server-minus'
                    });
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#screenLoader');
                });
        }

        $scope.addLocalization = function() {
            $scope.editedMenu.localization.push({
                lang: $scope.locLangs[0],
                title: '',
            })
        }

        $scope.addEditMenu = function (menu, index) {
            $scope.editedMenu = {
                option: $scope.menuOptions[0],
                icon: {},
                title: {},
                customTitle: '',
                localization: [],
                new: true,
            }
            if (menu) {
                $scope.editedMenu.new = false;
            }
            $scope.setMenu(menu)

            var inner = $templateCache.get('ui-add-edit-menu.tpl.html');
            inner = $compile(inner)($scope);

            $scope.menuValidateErrors = {
                customTitle: false,
            };

            $scope.window = ModalWindowService.Open({
                content: inner,
                clear: true,
                isFixed: true,
                keyboard: true,
                actions: [
                    {
                        title: $scope.editedMenu.new ? 'Add' : 'Save',
                        color: 'green',
                        check: function () {
                            var valid = true;
                            $scope.editedMenu.customTitle = $scope.editedMenu.customTitle.trim()
                            if ($scope.editedMenu.title.id === 'custom' && !$scope.editedMenu.customTitle) {
                                $scope.menuValidateErrors.customTitle = true;
                                valid = false;
                            }
                            return valid;
                        },
                        fn: function () {
                            var processed = convertEditedMenuToJsonAPI()
                            if (menu) {
                                $scope.menu[index] = processed
                            } else {
                                $scope.menu.push(processed)
                            }
                            $rootScope.$digest();
                        }
                    },
                    {
                        title: 'Cancel',
                        color: 'red',
                        fn: function () {
                            $rootScope.hideLinearProgress('#modalLoader');
                        }
                    }
                ],
                size: {
                    s: 12,
                    l: 4
                }
            });
        }

        $scope.assetOrderChanged = function (asset, index) {
            var newOrder = Number(asset.order)
            if (newOrder <= 0 || newOrder > $scope.rail.assets.length) {
                $scope.rail.assets[index].order = index + 1;
                return;
            }

            if (index === newOrder - 1) {
                return
            }

            $scope.rail.assets.splice(index, 1)

            $scope.rail.assets.splice(newOrder-1, 0, asset);
            for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                $scope.rail.assets[i].order = i + 1;
            }
        }

        $scope.assetMoved = function(index) {
            $scope.rail.assets.splice(index, 1);
            for (var i = 0; i < $scope.rail.assets.length; i += 1) {
                $scope.rail.assets[i].order = i + 1;
            }
        }

        $scope.railMoved = function(index) {
            $scope.screen.rails.splice(index, 1);
            for (var i = 0; i < $scope.screen.rails.length; i += 1) {
                $scope.screen.rails[i].order = i + 1;
            }
        }

        $scope.railOrderChanged = function (rail, index) {
            var newOrder = Number(rail.order)
            if (newOrder <= 0 || newOrder > $scope.screen.rails.length) {
                $scope.screen.rails[index].order = index + 1;
                return;
            }

            if (index === newOrder - 1) {
                return
            }

            $scope.screen.rails.splice(index, 1)

            $scope.screen.rails.splice(newOrder-1, 0, rail);
            for (var i = 0; i < $scope.screen.rails.length; i += 1) {
                $scope.screen.rails[i].order = i + 1;
            }
        }

    }
  ]);
